// extracted by mini-css-extract-plugin
export default {"templateMenuContent":"MenuAndNavbarTemplate_templateMenuContent__Y2Otb","templateMenuContentFull":"MenuAndNavbarTemplate_templateMenuContentFull__F593L"};